import React, {Component} from "react";  import config from 'react-global-configuration';
import {Input} from 'reactstrap';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import {css} from "@emotion/core";
import * as moment from "moment";
import {connect}  from  "react-redux";
import loadingGif from "../../assets/img/loading.gif";
import {BeatLoader} from "react-spinners";
import {confirmAlert} from 'react-confirm-alert';
import { isApiResponse, isReportAccess, date_range_config, aplloClient, unauthorize_access,user_activities } from '../../helpers/utils.js';
import MultiCsvReportDownload from '../DownloadReport/MultiCsvReportDownload.jsx';
import MerchantFilter from '../../filters/MerchantFilter.jsx';
import ChainFilter from '../../filters/ChainFilter.jsx';
import StoreFilter from '../../filters/StoreFilter.jsx';
import UtidFilter from '../../filters/UtidFilter.jsx';
import ServiceFilter from '../../filters/ServiceFilter.jsx';
import TenderModeFilter from '../../filters/TenderModeFilter.jsx';
import TxnTypeFilter from '../../filters/TxnTypeFilter1.jsx';
import DateRangeFilter from '../../filters/DateRangeFilter.jsx';
import IssuerFilter from '../../filters/IssuerFilter.jsx';
import SchemeFilter from '../../filters/SchemeFilter.jsx';
import CardLogoFilter from '../../filters/CardLogoFilter.jsx';
import CityFilter from '../../filters/CityFilter.jsx';
import AcquirerFilter from '../../filters/AcquirerFilter.jsx';
import TransactionMediumFilter from '../../filters/TransactionMediumFilter.jsx';
import ProductTypeFilter from '../../filters/ProductTypeFilter.jsx';
import IndustryCategoryFilter from '../../filters/IndustryCategoryFilter.jsx';
import FallBackFilter from '../../filters/FallBackFilter.jsx';
import PosbillFilter from '../../filters/PosbillFilter.jsx';
import PrimIdFilter from '../../filters/PrimIdFilter.jsx';
import SkuFilter from '../../filters/SkuFilter.jsx';
import InternationalDomesticFilter from '../../filters/InternationalDomesticFilter.jsx';
import AxisATPFilter from '../../filters/AxisATPFilter.jsx';
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;
var date_config = date_range_config('0', '0', new Date(Date.now()),'0');
var LiveTraTable='';
class LiveTransactionReport extends Component{
    constructor(props) {
        super(props);
        this.state ={
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit:date_config.end_date_limit,
            merchantID:'',
            chainID:'',
            storeID:'',
            acqBankIds:'',
            issuerBankIds:'',
            cityIds:'',
            loading:false,
            is_void: 1,
            cardGradeIDs:'',
            schemeIDs:'',
            cardTypeIDs:'',
            txnissuerIDs:'',
            tenderModeIDs:'',
            txnTypeIDs: ['SALE'],
            ciutidIds: '',
            slipData:'',
            isSettledIDs: '',
            is_fallback: 0,
            isChange: false,
            is_posbillinput: 0,
            is_prim_id:0,
            merchant_sku: 0,
            productTypeIDs: '',
            serviceTypeIDs: '',
            object_code:[],
            communicationIdIds:'',
            industryCategoryIds:'',
            isInternational:'',
            is_extra_column: 'no',
            extraColumns:[],
            extra_columns_query:'',
            extra_columns_merchant:'',
            state_code:'',
            axis_atp:0,
            ubcSlipData:'',
            invoiceNumber:'',
            CustomerContact:'',
            amountFilterType:'equal',
            min_amount:'',
            max_amount:''
        }

    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        let isExtraColumns = localStorage.is_extra_column;
        if(isExtraColumns==='yes') {
            let column_array=[];
            if(localStorage.extra_columns!='' || localStorage.extra_columns!=undefined) {
                column_array = localStorage.extra_columns.split(",");
            }
            this.setState({
                is_extra_column: isExtraColumns,
                extraColumns:column_array,
                extra_columns_query:localStorage.extra_columns_query,
                extra_columns_merchant:localStorage.extra_columns_merchant
            })

        }
        isReportAccess(AllAccessPermissions, 'live_transaction');
        if(decoded.object_type==='Merchant'){
            this.setState({
                merchantID: arrayCode
            })
        }
        if(decoded.object_type==='Chain'){
            this.setState({
                chainID: arrayCode
            })
        }
        if(decoded.object_type==='Store'){
            this.setState({
                storeID: arrayCode
            })
        }

        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType,
        });
        if(decoded.userGroupName==='Meta Users')
        {
            if(decoded.object_type==='Innoviti')
            {
                var state_code = localStorage.state_code;

                if(state_code=='' || state_code=='null' || state_code==null || state_code==undefined) {
                    this.setState({
                        state_code: '',
                        productTypeIDs:'True EMI'
                    })

                } else {
                    var state_arr = state_code.split(",");
                    this.setState({
                        state_code: state_arr,
                        productTypeIDs:'True EMI'
                    })

                }
            } else {
                unauthorize_access();
            }
       }
    }
    componentDidUpdate() {

    }
    componentDidMount() {
        this.get_filtered_live_transaction_report(this.state.object_type,this.state.object_code,'');
        user_activities(0, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email,'live_txn_report','sparcs')
    }

    downLoadLiveTraReportCheck (e){
        let transaction_type = this.state.txnTypeIDs;
        if (Array.isArray(this.state.txnTypeIDs) && this.state.txnTypeIDs.includes("all") === true) {
            transaction_type = ""
        }
        let filters = {
            merchant_codes: this.state.merchantID,
            chain_codes: this.state.chainID,
            store_codes: this.state.storeID,
            acq_bank_codes: this.state.acqBankIds,
            city: this.state.cityIds,
            transaction_type: transaction_type,
            settlement_status: this.state.isSettledIDs,
            show_fallback_flag: this.state.is_fallback,
            show_pos_bill_input_columns: this.state.is_posbillinput,
            show_txn_prim_id: this.state.is_prim_id,
            product_type: this.state.productTypeIDs,
            service_type: this.state.serviceTypeIDs,
            start_date: this.state.yestSend,
            end_date: this.state.todSend,
            show_void_transactions: this.state.is_void,
            scheme: this.state.schemeIDs,
            credit_debit: this.state.cardTypeIDs,
            issuer_bank: this.state.txnissuerIDs,
            tender_mode: this.state.tenderModeIDs,
            live_or_daily: "live",
            utid: this.state.ciutidIds,
            communication_id: this.state.communicationIdIds,
            merchant_sku: this.state.merchant_sku,
            category_code: this.state.industryCategoryIds,
            download: 1,
            is_international_card: this.state.isInternational,
            is_extra_column: this.state.is_extra_column,
            extra_columns:this.state.extraColumns,
            extra_columns_query:this.state.extra_columns_query,
            extra_columns_merchant: this.state.extra_columns_merchant,
            report_code:"live_txn_report",
            user_id: this.state.user_id,
            state_code: this.state.state_code,
            axis_atp: this.state.axis_atp,
            ci_bill_invoice_no: this.state.invoiceNumber,
            ci_customer_mobile_number: this.state.CustomerContact,
            amountFilterType: this.state.amountFilterType,
            min_amount: this.state.min_amount,
            max_amount: this.state.max_amount
        }
        this.setState({
            filters:filters
        })
    let is_txn = false;
    if(this.state.txnTypeIDs.length===1 && this.state.txnTypeIDs[0]==='SALE')
    {
       is_txn = true;
    }
    if(this.state.merchantID==='' && this.state.chainID==='' && this.state.storeID==='' && this.state.ciutidIds==='' && this.state.acqBankIds===''
    && this.state.cityIds==='' && this.state.tenderModeIDs==='' && this.state.txnissuerIDs==='' && this.state.schemeIDs===''
    && this.state.cardTypeIDs==='' && this.state.isSettledIDs==='' && this.state.productTypeIDs==='' && this.state.serviceTypeIDs==='' && is_txn ===true
    && this.state.communicationIdIds===''){
      confirmAlert({
            //title: 'Warning',
            message: "Do you really want to download all data for date range: "+this.state.datefromShow+" - "+this.state.dateToShow+" ? This will take some time to download depending on volume of data. Alternatively, please apply a filter.",
            buttons: [{
                label: 'OK',
                onClick: () => {
                    this.refs.downloadAllReport.downLoadReport(filters, '/report/transaction/daily','live_transaction_report');
                }
            },
                {
                    label: 'Cancel',
                }
            ]
        });
        } else {
            //setTimeout(function(){
                this.refs.downloadAllReport.downLoadReport(filters, '/report/transaction/daily','live_transaction_report');
            //}.bind(this), 200);
        }
    }

    get_filtered_live_transaction_report(object_type, object_code, event) {

        var that = this;
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
        var obj_code = this.state.object_code;
        var fcol = 'Merchant';
        if(that.state.is_fallback==1){
            fcol = 'Fallback';
        }
        var corCol = 'Merchant';
        var ufeCol = 'Merchant';
        if(that.state.txnTypeIDs.includes("FAILED")===true || that.state.txnTypeIDs.includes("all")===true) {
            corCol = 'Co Reason Message';
            ufeCol = 'Ufe Message';
        }
        if(that.state.is_prim_id===1){
            var parent_prim_id = "prim_id";
            if(that.state.txnTypeIDs.includes("SALE")===false) {
                parent_prim_id = 'parent_prim_id';

            }
        }
        var pos_order_id = 'Merchant';
        var grab_order_id = 'Merchant';
        var grab_client_id = 'Merchant';
        var pos_merchant = 'Merchant';
        var UHID = 'Merchant';
        var Bill_No = 'Merchant';
        var Episode_No = 'Merchant';
        var merchant_sku = 'Merchant';
        if(that.state.merchant_sku===1) {
            merchant_sku = 'Merchant SKU';
        }
        if(that.state.is_posbillinput==1){
            grab_order_id = 'Grab Order ID';
            pos_order_id = 'Pos Order ID';
            grab_client_id = 'Grab Client ID';
            pos_merchant = 'Pos Merchant ID';
            if(this.state.merchantID===''&& this.state.chainID===''&& this.state.storeID===''){
                UHID = 'UHID';
                Bill_No = 'Bill No';
                Episode_No = 'Episode No';
            }
            if(aplloClient.some(r=> obj_code.includes(r))===true) {
                 UHID = 'UHID';
                 Bill_No = 'Bill No';
                 Episode_No = 'Episode No';
            }
            if(this.state.merchantID!==''){
                if(aplloClient.some(r=> merchants.includes(r))===true){
                    UHID = 'UHID';
                    Bill_No = 'Bill No';
                    Episode_No = 'Episode No';
                }
            }
            if(this.state.chainID!==''){
                if(aplloClient.some(r=> chains.includes(r))===true){
                    UHID = 'UHID';
                    Bill_No = 'Bill No';
                    Episode_No = 'Episode No';
                }
            }
            if(this.state.storeID!==''){
                if(aplloClient.some(r=> stores.includes(r))===true){
                    UHID = 'UHID';
                    Bill_No = 'Bill No';
                    Episode_No = 'Episode No';
                }
            }
        }


        isApiResponse(false)

        if(object_type === 'Merchant' && this.state.merchantID===''){
            merchants = object_code;
        }
        if(object_type==='Chain' && this.state.chainID===''){
            chains = object_code;
        }
        if(object_type==='Store' && this.state.storeID===''){
            stores = object_code;
        }

        var postData = {
            mids: merchants,
            cids: chains,
            sids: stores,
            bids: this.state.acqBankIds,
            cityids: this.state.cityIds,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            is_void: this.state.is_void,
            card_grade: this.state.cardGradeIDs,
            scheme: this.state.schemeIDs,
            cedit_debit: this.state.cardTypeIDs,
            transaction_type: this.state.txnTypeIDs,
            utid: this.state.ciutidIds,
            tender_mode: this.state.tenderModeIDs,
            issuer: this.state.txnissuerIDs,
            txn_type: "",
            live_or_daily: "live",
            is_settled: this.state.isSettledIDs,
            is_fallback: this.state.is_fallback,
            is_posbillinput: this.state.is_posbillinput,
            show_txn_prim_id: this.state.is_prim_id,
            product_type: this.state.productTypeIDs,
            service_type: this.state.serviceTypeIDs,
            communication_id:this.state.communicationIdIds,
            merchant_sku: this.state.merchant_sku,
            industry_code: this.state.industryCategoryIds,
            isInternational: this.state.isInternational,
            is_extra_column: this.state.is_extra_column,
            extra_columns:this.state.extraColumns,
            extra_columns_query:this.state.extra_columns_query,
            extra_columns_merchant: this.state.extra_columns_merchant,
            state_code: this.state.state_code,
            axis_atp: this.state.axis_atp,
            ci_bill_invoice_no: this.state.invoiceNumber,
            ci_customer_mobile_number: this.state.CustomerContact,
            amountFilterType: this.state.amountFilterType,
            min_amount: this.state.min_amount,
            max_amount: this.state.max_amount
        };
        if ($.fn.DataTable.isDataTable('#LiveTraTable')) {
            $('#LiveTraTable').DataTable().clear().destroy();
        }
        let allColumns = ''
        let mc = ''
        if(this.state.merchantID==''){
            mc = [];
        }
        else {
            mc = this.state.merchantID
        }
        var ubcIndex = this.state.extraColumns.indexOf("UBC digital Invoice");
        var ubc_digital_invoice = 'Merchant';
        if (ubcIndex !== -1) {
            ubc_digital_invoice = "UBC digital Invoice"
        }
        if(this.state.object_code.includes("LVIS0338")===true || mc.includes("LVIS0338"))
        {
            allColumns = [
            {"data":"Merchant",  "width": "150px",},
            {"data":"Chain",  "width": "150px",},
            {"data":"Store",  "width": "150px",},
            {"data":"Store Address", "width": "200px"},
            {"data": "City"},
            {"data": "State", "width": "80px"},
            {"data": "echargeslip_url"},
            {"data":ubc_digital_invoice},
            {"data": "Product Amount"},
            {"data": "Sale Amount"},
            {"data": "Transaction Amount"},
            {"data": "Loan Amount"},
            {"data": "EMI Amount"},
            {"data": "Instant Discount/Cashback"},
            {"data": "No Cost EMI Amount"},
            {"data": "Additional Cashback"},
            {"data": "Transaction Date"},
            {"data": "Transaction Time"},
            {"data": "Bank Merchant Id"},
            {"data": "Btid"},
            {"data": "Utid"},
            {"data": "Card Number"},
            {"data": "Bin No"},
            {"data": "Acquiring Bank"},
            {"data": "Issuer Bank"},
            {"data": "Tender Mode"},
            {"data": "Scheme"},
            {"data": "Grade"},
            {"data": "Logo"},
            {"data": "Credit/Debit"},
            {"data": "UPI Account Type"},
            {"data": "RRN No"},
            {"data": "Acquirer RRN Number"},
            {"data": "Approval Code"},
            {"data": "Merchant Invoice Number"},
            {"data": "Batchsrl"},
            {"data": "Invoice"},
            {"data":"Processing Code"},
            {"data": "Transaction Type"},
            {"data": "Card Holder Name"},
            {"data": "Is DCC Transaction"},
            {"data": "Is International Card"},
            {"data": "Transaction Medium"},
            {"data":"Software Version"},
            {"data": "Terminal Serial Number"},
            {"data": "PNR Number"},
            {"data":"Settlement Date"},
            {"data":"Settled/Unsettled"},
            {"data":fcol},
            {"data":corCol},
            {"data":ufeCol},
            {"data":grab_order_id },
            {"data":pos_order_id },
            {"data":grab_client_id },
            {"data":pos_merchant },
            {"data":"prim_id" },
            {"data":"parent_prim_id"},
            {"data":UHID },
            {"data":Bill_No },
            {"data":Episode_No },
            {"data":"Brand"},
            {"data":merchant_sku },
            {"data":"Category"},
            {"data":"service type" , "width": "200px"},
            {"data":"Innoviti Convenience Fee"},
            {"data":"Industry Category"},
            {"data":"UPI Transaction ID"},
            {"data":"ProviderReferenceID"}

        ]
        } else {
            allColumns = [
            {"data":"Merchant",  "width": "150px",},
            {"data":"Chain",  "width": "150px",},
            {"data":"Store",  "width": "150px",},
            {"data":"Store Address", "width": "200px"},
            {"data": "City"},
            {"data": "State", "width": "80px"},
            {"data": "echargeslip_url"},
            {"data":ubc_digital_invoice},
            {"data": "Product Amount"},
            {"data": "Sale Amount"},
            {"data": "Transaction Amount"},
            {"data": "Loan Amount"},
            {"data": "EMI Amount"},
            {"data": "Instant Discount/Cashback"},
            {"data": "No Cost EMI Amount"},
            {"data": "Additional Cashback"},
            {"data": "Transaction Date"},
            {"data": "Transaction Time"},
            {"data": "Bank Merchant Id"},
            {"data": "Btid"},
            {"data": "Utid"},
            {"data": "Card Number"},
            {"data": "Bin No"},
            {"data": "Acquiring Bank"},
            {"data": "Issuer Bank"},
            {"data": "Tender Mode"},
            {"data": "Scheme"},
            {"data": "Grade"},
            {"data": "Logo"},
            {"data": "Credit/Debit"},
            {"data":"UPI Account Type"},
            {"data": "RRN No"},
            {"data": "Acquirer RRN Number"},
            {"data": "Approval Code"},
            {"data": "Merchant Invoice Number"},
            {"data": "Batchsrl"},
            {"data": "Invoice"},
            {"data":"Processing Code"},
            {"data": "Transaction Type"},
            {"data": "Card Holder Name"},
            {"data": "Is DCC Transaction"},
            {"data": "Is International Card"},
            {"data": "Transaction Medium"},
            {"data":"Software Version"},
            {"data": "Terminal Serial Number"},
            {"data": "Bill Invoice Number"},
            {"data":"Settlement Date"},
            {"data":"Settled/Unsettled"},
            {"data":fcol},
            {"data":corCol},
            {"data":ufeCol},
            {"data":grab_order_id },
            {"data":pos_order_id },
            {"data":grab_client_id },
            {"data":pos_merchant },
            {"data":"prim_id" },
            {"data":"parent_prim_id"},
            {"data":UHID },
            {"data":Bill_No },
            {"data":Episode_No },
            {"data":"Brand"},
            {"data":merchant_sku },
            {"data":"Category"},
            {"data":"service type" , "width": "200px"},
            {"data":"Innoviti Convenience Fee"},
            {"data":"Industry Category"},
            {"data":"UPI Transaction ID"},
            {"data":"ProviderReferenceID"}

        ]
        }

        this.state.extraColumns.map((column_name, i) => {
            if (column_name !== "UBC digital Invoice") {
                allColumns.push({ "data": column_name });
            }
        });


        LiveTraTable = $('#LiveTraTable').DataTable(
            {
                order:[],
                //"dom": 'fltip',
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                //"autoWidth": true,
                "responsive": false,
                "scrollX": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/reports/eod-transaction-reports",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) { //console.log("amondon"); console.log(json);
                        isApiResponse(true);
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        isApiResponse(true);
                        alert("Failed to load data. Please try again");
                        console.log("error", data);
                    },
                    complete: function (data) {
                        isApiResponse(true)
                    },
                },

                columns: allColumns,
                "columnDefs": [

                    {
                        render: function (data, type, row) {
                            if(row['Settled/Unsettled']==="Failed" || row['Settled/Unsettled']==="FAILED") {
                                return '<td ></td>';
                            }
                            else{
                                return '<td ><a href="#" data-code ="' + data + '" data-trdate ="' + row['Transaction Date'] + '" data-acqbank ="' + row['Acquiring Bank'] + '" data-primid ="' + row['prim_id'] + '">Get Receipt</a> &nbsp;</td>';
                            }
                        },
                        className: "charge_slip",
                        targets: 6,
                        aTargets: [ -1 ]
                    },
                    {
                        render: function (data, type, row) {

                            if(row['Settled/Unsettled']==="Failed" || row['Settled/Unsettled']==="FAILED" || row['UBC digital Invoice']===null || row['UBC digital Invoice']==="" || row['UBC digital Invoice'] ==='null') {
                                return '<td ></td>';
                            }
                            else{
                                return '<td ><a href="#" data-code ="' + data + '" data-trdate ="' + row['Transaction Date'] + '" data-acqbank ="' + row['Acquiring Bank'] + '" data-primid ="' + row['prim_id'] + '">UBC digital Invoice</a> &nbsp;</td>';
                            }

                        },
                        className: "ubc_charge_slip",
                        targets: 7,
                        aTargets: [ -1 ]
                    },
                    {  render: function (data) {
                            return '<td >'+moment(data).format('D MMM YYYY')+'</td>';
                        },
                        "width": "80px",
                        "targets": 16
                    },
                    {
                        render: function (data, type, full, meta) {
                            if(data===null || data===''|| data ==='null'){
                            data = '';
                            }
                            return "<div class='text-wrap width-150'>" + data + "</div>";
                        },
                        "targets": [0,1,2,3]
                    }

                ]

            });
        if(that.state.is_fallback==1) {
            LiveTraTable.columns(48).visible(true);
        }
        else {
            LiveTraTable.columns(48).visible(false);
        }
        if(that.state.txnTypeIDs.includes("FAILED")===true  || that.state.txnTypeIDs.includes("all")===true) {
            LiveTraTable.columns(49).visible(true);
            LiveTraTable.columns(50).visible(true);
            //LiveTraTable.columns(7).visible(false);
        } else {
            //LiveTraTable.columns(7).visible(true);
            LiveTraTable.columns(49).visible(false);
            LiveTraTable.columns(50).visible(false);
        }
         if(that.state.txnTypeIDs.includes("UPI Leg1")===true) {

            LiveTraTable.columns(6).visible(false);
        } else {
            LiveTraTable.columns(6).visible(true);

        }
        if (this.state.txnTypeIDs.includes("UPI Leg1") === true || ubc_digital_invoice !== "UBC digital Invoice") {
            LiveTraTable.columns(7).visible(false);
        } else {
            LiveTraTable.columns(7).visible(true);
        }
        LiveTraTable.columns(57).visible(false);
        LiveTraTable.columns(58).visible(false);
        LiveTraTable.columns(59).visible(false);
        if(that.state.is_posbillinput===1) {
            LiveTraTable.columns(51).visible(true);
            LiveTraTable.columns(52).visible(true);
            LiveTraTable.columns(53).visible(true);
            LiveTraTable.columns(54).visible(true);
            if(this.state.merchantID===''&& this.state.chainID===''&& this.state.storeID===''){
                LiveTraTable.columns(57).visible(true);
                LiveTraTable.columns(58).visible(true);
                LiveTraTable.columns(59).visible(true);
            }

            if(aplloClient.some(r=> obj_code.includes(r))===true) {
                LiveTraTable.columns(57).visible(true);
                LiveTraTable.columns(58).visible(true);
                LiveTraTable.columns(59).visible(true);
                LiveTraTable.columns(51).visible(false);
                LiveTraTable.columns(52).visible(false);
                LiveTraTable.columns(53).visible(false);
                LiveTraTable.columns(54).visible(false);
            }
            if(this.state.merchantID!==''){
                if(aplloClient.some(r=> merchants.includes(r))===true){
                    LiveTraTable.columns(57).visible(true);
                    LiveTraTable.columns(58).visible(true);
                    LiveTraTable.columns(59).visible(true);
                    LiveTraTable.columns(51).visible(false);
                    LiveTraTable.columns(52).visible(false);
                    LiveTraTable.columns(53).visible(false);
                    LiveTraTable.columns(54).visible(false);
                }
            }
            if(this.state.chainID!==''){
                if(aplloClient.some(r=> chains.includes(r))===true){
                    LiveTraTable.columns(57).visible(true);
                    LiveTraTable.columns(58).visible(true);
                    LiveTraTable.columns(59).visible(true);
                    LiveTraTable.columns(51).visible(false);
                    LiveTraTable.columns(52).visible(false);
                    LiveTraTable.columns(53).visible(false);
                    LiveTraTable.columns(54).visible(false);
                }
            }
            if(this.state.storeID!==''){
                if(aplloClient.some(r=> stores.includes(r))===true){
                     LiveTraTable.columns(57).visible(true);
                    LiveTraTable.columns(58).visible(true);
                    LiveTraTable.columns(59).visible(true);
                    LiveTraTable.columns(51).visible(false);
                    LiveTraTable.columns(52).visible(false);
                    LiveTraTable.columns(53).visible(false);
                    LiveTraTable.columns(54).visible(false);
                }
            }
        } else {
            LiveTraTable.columns(51).visible(false);
            LiveTraTable.columns(52).visible(false);
            LiveTraTable.columns(53).visible(false);
            LiveTraTable.columns(54).visible(false);
        }
        if(that.state.is_prim_id===1) {
            LiveTraTable.columns(55).visible(true);
            if(that.state.txnTypeIDs.includes("REVERSAL")===true || that.state.txnTypeIDs.includes("VOID")===true || that.state.txnTypeIDs.includes("FAILED")===true|| that.state.txnTypeIDs.includes("all")===true) {
                LiveTraTable.columns(56).visible(true);
            } else {
                LiveTraTable.columns(56).visible(false);
            }
        } else {
            LiveTraTable.columns(55).visible(false);
            LiveTraTable.columns(56).visible(false);
        }
        if(that.state.merchant_sku===1) {
            LiveTraTable.columns(61).visible(true);
        } else {
            LiveTraTable.columns(61).visible(false);
        }

        $('#LiveTraTable').on('click', 'td.charge_slip a', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            var code = $(this).data("code");
            var acqbank = $(this).data("acqbank");
            var trdate = $(this).data("trdate");
            var prim_id = $(this).data("primid");

            let win=window.open('about:blank','popUpWindow', 'height=500,width=400,left=100,top=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes' )
            var perLoad = '<div style="text-align: center" id="loaderDiv"><img src=" '+ loadingGif +' "></div>';
            win.document.write(perLoad)

            $.ajax({
                url:config.get('API_URL')+ "/reports/generate_slip/?code="+code+"&acq_bank_name="+acqbank+"&transaction_date="+trdate+"&prim_id="+prim_id,
                type: 'GET',

                beforeSend: function (request) {
                    request.setRequestHeader("Authorization", localStorage.usertoken);
                },
                success: function (response) {
                    that.setState({
                        opened: true,
                        chargeSlipPopup: true,
                        slipData:response
                    })
                    win.document.close();
                    win.document.write(that.state.slipData);
                },
                //dataType: 'html'
            })
        })

        $('#LiveTraTable').on('click', 'td.ubc_charge_slip a', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            var code = $(this).data("code");
            //alert(code)
            var acqbank = $(this).data("acqbank");
            var trdate = $(this).data("trdate");
            var prim_id = $(this).data("primid");

            let win=window.open('about:blank','popUpWindowUBCSlip', 'height=500,width=400,left=100,top=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes' )
            var perLoad = '<div style="text-align: center" id="loaderDiv"><img src=" '+ loadingGif +' "></div>';
            win.document.write(perLoad)

            $.ajax({
                url:config.get('API_URL')+ "/reports/generate_ubc_slip/?ubc_url="+code+"&acq_bank_name="+acqbank+"&transaction_date="+trdate+"&prim_id="+prim_id,
                type: 'GET',

                beforeSend: function (request) {
                    request.setRequestHeader("Authorization", localStorage.usertoken);
                },
                success: function (response) {
                    that.setState({
                        ubcopened: true,
                        UbcChargeSlipPopup: true,
                        ubcSlipData:response
                    })
                    win.document.close();
                    win.document.write(that.state.ubcSlipData);
                },
                //dataType: 'html'
            })
        })
    }


    reset_all(e){
        this.refs.daterangeFilter.restDateFilter(date_config.start_date,date_config.end_date,date_config.display_start_date, date_config.display_end_date, date_config.start_date_value,date_config.end_date_value);
        if(this.state.object_type==='Innoviti')
        {
            this.refs.merchantFilter.restMerchantFilter();
            this.refs.reloadChain.getChain(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code);
            this.refs.reloadStore.getStore(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code, false,'');
            this.refs.reloadUtid.ci_utid('','','',false,'');
        }
        if(this.state.object_type==='Merchant')
        {
            this.refs.reloadChain.getChain(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code);
            this.refs.reloadStore.getStore(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code,false,'');
            this.refs.reloadUtid.ci_utid(this.state.object_code,'','',false,'');
        }
        if(this.state.object_type==='Chain')
        {
            this.refs.reloadStore.getStore(this.state.object_code, 'chain', this.state.object_type, this.state.object_code,false,'');
            this.refs.reloadUtid.ci_utid('',this.state.object_code,'',false,'');
        }
        if(this.state.object_type==='Store')
        {
            this.refs.reloadUtid.ci_utid('','',this.state.object_code,false,'');
        }
        if(this.state.object_type=='Innoviti' || this.state.object_code.includes("RELI0001")===true)
        {
            this.refs.serviceFilter.restServiceFilter();
            this.refs.productTypeFilter.resetProductTypeFilter();

        }
        this.refs.tenderModeFilter.restTenderModeFilter();
        this.refs.txnTypeFilter.resetTxnTypeFilter();
        this.refs.reloadIssuer._txn_issuer_bank(date_config.start_date_value, date_config.end_date_value);
        this.refs.schemeFilter.resetScheme();
        this.refs.cardFilter.resetCard();
        this.refs.cityFilter.resetCityFilter();
        this.refs.acquirerFilter.resetAcquirerFilter();
        this.refs.transactionMediumFilter.resetTransactionMediumFilter();
        this.refs.industryCategoryFilter.resetIndustryCategoryFilter();
        this.refs.fallBackFilter.resetFallBackFilter();
        this.refs.posbillFilter.resetPosbillFilter();
        this.refs.primIdFilter.resetPrimIdFilter();
        this.refs.skuFilter.resetSkuFilter();
        this.refs.internationalFilter.resetInternationalFilter();
        this.refs.axisAtpFilter.resetAxisAtpFilter();
        this.setState({
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            merchantID:'',
            chainID:'',
            storeID:'',
            acqBankIds:'',
            issuerBankIds:'',
            cityIds:'',
            is_void:1,
            cardGradeIDs:'',
            schemeIDs:'',
            cardTypeIDs:'',
            txnissuerIDs:'',
            emiIssuerIDs:'',
            txnTypeIDs: ['SALE'],
            ciutidIds: '',
            isSettledIDs: '',
            isChange: false,
            is_posbillinput: 0,
            is_prim_id:0,
            merchant_sku:0,
            tenderModeIDs:'',
            is_fallback: 0,
            serviceTypeIDs: '',
            productTypeIDs: '',
            communicationIdIds:'',
            industryCategoryIds:'',
            isInternational:'',
            axis_atp:0,
            ubcSlipData:'',
            invoiceNumber:'',
            CustomerContact:'',
            amountFilterType:'equal',
            min_amount:'',
            max_amount:''
        })

        setTimeout(function(){
            this.componentWillMount()
            this.componentDidMount()
        }.bind(this), 200);
    }
    handleDateRange = (todSend, yestSend, datefromShow,dateToShow) =>
    {
        this.setState({
            todSend: todSend,
            yestSend: yestSend,
            datefromShow: datefromShow,
            dateToShow: dateToShow,
            isChange: true,
        });
        this.refs.reloadIssuer._txn_issuer_bank(yestSend, todSend);

    }
    handleMerchant = (optionSelected, merchantID) =>
    {
        this.setState({
            merchantID:merchantID,
            isChange: true,
            chainID:'',
            storeID:'',
            ciutidIds: '',
        });
        this.refs.reloadChain.getChain(merchantID, 'merchant', this.state.object_type, this.state.object_code);
        this.refs.reloadStore.getStore(merchantID, 'merchant', this.state.object_type, this.state.object_code,false,'');
        this.refs.reloadUtid.ci_utid(merchantID, '','',false,'');
    }
    handleChain = (optionSelected, chainID) =>
    {
        this.setState({
            chainID:chainID,
            isChange: true,
            storeID:'',
            ciutidIds: '',
        });
        this.refs.reloadStore.getStore(chainID, 'chain', this.state.object_type, this.state.merchantID,false,'');
        this.refs.reloadUtid.ci_utid(this.state.merchantID, chainID,'',false,'');
    }

    handleStore = (storeID) =>
    {
        this.setState({
            storeID:storeID,
            isChange: true,
            ciutidIds: '',

        });
        this.refs.reloadUtid.ci_utid(this.state.merchantID, this.state.chainID,storeID,false,'');
    }
    handleUtid = (utid) =>
    {
        this.setState({
            ciutidIds:utid,
            isChange: true
        });

    }

    handleService = (serviceData) =>{
        const value = serviceData === null ? '' : serviceData.value;
        this.setState({
            isChange: true,
            serviceTypeIDs:value,
        })
    }
    handleTenderMode = (optionSelected, tenderModeIDs) =>
    {
        this.setState({
            tenderModeIDs:tenderModeIDs,
            isChange: true
        });
    }
    handleTxnType = (optionSelected, txnTypeIDs) =>
    {
        this.setState({
            txnTypeIDs:txnTypeIDs,
            isChange: true
        });
    }

    handleIssuer = (optionSelected, issuerArray) =>
    {
        this.setState({
            txnissuerIDs:issuerArray,
            isChange: true
        });
    }
    handleScheme = (optionSelected, schemeArray) =>
    {
        this.setState({
            schemeIDs:schemeArray,
            isChange: true
        });
    }
    handleCard = (optionSelected, ceditArray) =>
    {
        this.setState({
            cardTypeIDs:ceditArray,
            isChange: true
        });
    }
   handleCity = (optionSelected, cityIds) =>
    {
        this.setState({
            cityIds:cityIds,
            isChange: true
        });
    }
    handleAcquirer = (optionSelected, acqBankIds) =>
    {
        this.setState({
            acqBankIds:acqBankIds,
            isChange: true
        });
    }
    handleTransactionMedium = (optionSelected, TransactionMediumIds) =>
    {
        this.setState({
            communicationIdIds:TransactionMediumIds,
            isChange: true
        });
    }
    handleProduct = (productData) =>{
        const value = productData === null ? '' : productData.value;
        this.setState({
            isChange: true,
            productTypeIDs:value,
        })
    }
    handleIndustryCategoryFilter = (optionSelected, industryCategoryIds) =>
    {
        this.setState({
            industryCategoryIds:industryCategoryIds,
            isChange: true
        });
    }
    handleInternationalFilter = (optionSelected) =>{
        const value = optionSelected === null ? '' : optionSelected.value;
        this.setState({
            isInternational:value,
            isChange: true
        });
    }
    handleFallBack = (is_fallback) => {
        this.setState({is_fallback: is_fallback, isChange: true});
    }
    handlePosBill = (is_posbillinput) => {
        this.setState({is_posbillinput: is_posbillinput, isChange: true});
    }
    handlePrimId = (is_prim_id) => {
        this.setState({is_prim_id: is_prim_id, isChange: true});
    }
    handleSKU = (merchant_sku) => {
        this.setState({merchant_sku: merchant_sku, isChange: true});
    }
    handleAxisAtp = (axis_atp) => {
        this.setState({axis_atp: axis_atp, isChange: true});
    }
     onChangeInput(e) {
        this.setState({ [e.target.name]: e.target.value, isChange: true });
    }
    render() {
        return(
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">Live Transaction Report</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
                                    <div className="row">
                                        <div className="col-md-10 filter-border-right">
                                            <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                                <div><label> Date Filter: </label></div>
                                                <DateRangeFilter ref="daterangeFilter" onSelectDate = {this.handleDateRange} start_date = {this.state.datefrom} end_date={this.state.dateTo} display_start_date = {this.state.datefromShow} display_end_date = {this.state.dateToShow}
                                                start_date_limit = {this.state.dateFromLimit} end_date_limit = {this.state.dateLimit}/>
                                            </div>
                                            {this.state.object_type ==='Innoviti'?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label>Merchants</label>
                                                    <MerchantFilter ref="merchantFilter" onSelectMerchant = {this.handleMerchant} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div> : null}
                                            {this.state.object_type ==='Innoviti' || this.state.object_type ==='Merchant'?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label> Chain </label>
                                                    <ChainFilter ref= "reloadChain" onSelectChain = {this.handleChain} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div>: null }
                                            {this.state.object_type ==='Innoviti' || this.state.object_type ==='Merchant' || this.state.object_type ==='Chain'?
                                                <div className="col-md-2 filter-bottom5 padd-5" >
                                                    <label> Store: </label>
                                                    <StoreFilter ref= "reloadStore" onSelectStore = {this.handleStore} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div>: null }
                                            <div className="col-md-2 filter-bottom5 padd-5" >
                                                <label> Utid: </label>
                                                <UtidFilter ref = "reloadUtid" onSelectUtid = {this.handleUtid} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                <div className="clearfix"></div>
                                            </div>
                                            {/*{this.state.acq_bank_list_box===true?*/}
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label>Acquirer:</label>
                                                <AcquirerFilter ref="acquirerFilter" onSelectAcquirer = {this.handleAcquirer} report="live_or_daily"/>
                                                <div className="clearfix"></div>
                                            </div>
                                            {/*: null }*/}
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label>Issuer:</label>
                                                <IssuerFilter ref= "reloadIssuer" onSelectIssuer = {this.handleIssuer} start_date = {this.state.yestSend} end_date={this.state.todSend}/>
                                                <div className="clearfix"></div>
                                            </div>

                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> City: </label>
                                                <CityFilter ref="cityFilter" onSelectCity = {this.handleCity}/>
                                                <div className="clearfix"></div>
                                            </div>

                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Scheme: </label>
                                                <SchemeFilter ref= "schemeFilter" onSelectScheme = {this.handleScheme} start_date = {this.state.yestSend} end_date={this.state.todSend}/>
                                                <div className="clearfix"></div>
                                            </div>

                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Card Logo: </label>
                                                <CardLogoFilter ref= "cardFilter" onSelectCard = {this.handleCard} start_date = {this.state.yestSend} end_date={this.state.todSend}/>
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Tender Mode </label>
                                                <TenderModeFilter ref="tenderModeFilter" onSelectTenderMode = {this.handleTenderMode} />
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Transaction Medium </label>
                                                <TransactionMediumFilter ref="transactionMediumFilter" onSelectTransactionMedium = {this.handleTransactionMedium} />
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Txn Type </label>
                                                <TxnTypeFilter ref="txnTypeFilter" onSelectTxnType = {this.handleTxnType} is_upi_leg1 = 'Yes' />
                                                <div className="clearfix"></div>
                                            </div>

                                            {this.state.object_type=='Innoviti' || this.state.object_code.includes("RELI0001")===true?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label> Product Type </label>
                                                    <ProductTypeFilter ref="productTypeFilter" onSelectProduct = {this.handleProduct} userType={this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div>: null }

                                            {this.state.object_type=='Innoviti' || this.state.object_code.includes("RELI0001")===true?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label> Service Type </label>
                                                    <ServiceFilter ref="serviceFilter" onSelectService = {this.handleService} userType={this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div>: null }
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Industry Category: </label>
                                                <IndustryCategoryFilter ref="industryCategoryFilter" onSelectIndustryCategoryFilter = {this.handleIndustryCategoryFilter}/>
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label>Is International Card: </label>
                                                <InternationalDomesticFilter ref="internationalFilter" onSelectInternationalFilter = {this.handleInternationalFilter}/>
                                                <div className="clearfix"></div>
                                            </div>
                                            {
                                          ["AHAR0050", "HARD0017"].includes(this.state.extra_columns_merchant) &&
                                          <>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                              <label>Invoice Number: </label>
                                              <Input
                                                name="invoiceNumber"
                                                value={this.state.invoiceNumber}
                                                onChange={this.onChangeInput.bind(this)}
                                              />
                                              <div className="clearfix"></div>
                                            </div>

                                            <div className="col-md-2 filter-bottom5 padd-5">
                                              <label>Customer Contact: </label>
                                              <Input
                                                name="CustomerContact"
                                                value={this.state.CustomerContact}
                                                onChange={this.onChangeInput.bind(this)}
                                              />
                                              <div className="clearfix"></div>
                                            </div>

                                            <div className="col-md-2 filter-bottom5 padd-5">
                                              <label>Amount Filter Type: </label>
                                              <select
                                                name="amountFilterType"
                                                onChange={this.onChangeInput.bind(this)}
                                                value={this.state.amountFilterType}
                                                className="form-control"
                                              >
                                                <option value="equal">Equal To</option>
                                                <option value="greater">Greater Than</option>
                                                <option value="less">Less Than</option>
                                                <option value="between">Between</option>
                                              </select>
                                            </div>

                                            <div className="col-md-1 filter-bottom5 padd-5">
                                              <label>
                                                {this.state.amountFilterType === 'between' ? 'Min Amount:' : 'Amount:'}
                                              </label>
                                              <Input
                                                name="min_amount"
                                                value={this.state.min_amount}
                                                onChange={this.onChangeInput.bind(this)}
                                              />
                                              <div className="clearfix"></div>
                                            </div>

                                            {this.state.amountFilterType === 'between' && (
                                              <div className="col-md-1 filter-bottom5 padd-5">
                                                <label>Max Amount: </label>
                                                <Input
                                                  name="max_amount"
                                                  value={this.state.max_amount}
                                                  onChange={this.onChangeInput.bind(this)}
                                                />
                                                <div className="clearfix"></div>
                                              </div>
                                            )}
                                          </>
                                        }


                                        </div>
                                        <div className="col-md-2 filter-bottom5 ">
                                            <div className="top-margin-30">
                                                <FallBackFilter ref="fallBackFilter" onSelectFallBack = {this.handleFallBack} />
                                            </div>
                                            <div>
                                                <PosbillFilter ref="posbillFilter" onSelectPosbill = {this.handlePosBill} />
                                            </div>
                                            <div>
                                                <PrimIdFilter ref="primIdFilter" onSelectPrimId = {this.handlePrimId} />
                                            </div>
                                            <div>
                                                <SkuFilter ref="skuFilter" onSelectSku = {this.handleSKU} />
                                            </div>
                                            <div>
                                                <AxisATPFilter ref="axisAtpFilter" onSelectAxisAtp = {this.handleAxisAtp} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-5 pull-right">
                                            {this.state.isChange===true?
                                                <span className="apply-notification">Please click on Apply button</span>:null
                                            }
                                            <button type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this.get_filtered_live_transaction_report.bind(this, this.state.object_type,this.state.object_code)}>Apply</button>
                                            <button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button>
                                        </div>
                                    </div>


                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                    <div className="">
                                        <a href="#" className="exportButton" role="button" onClick={this.downLoadLiveTraReportCheck.bind(this)}>
                                            <i className="fa fa-download" aria-hidden="true"></i>
                                            Export to CSV
                                        </a>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="content-tdetails-table table-full-width marginTop0">
                                        <table id="LiveTraTable" className="table table-striped table-hover">
                                            <thead>
                                            <tr>
                                                <th width="150px">Merchant</th>
                                                <th width="150px">Chain</th>
                                                <th width="150px">Store</th>
                                                <th width="200px">Store Address</th>
                                                <th>City</th>
                                                <th width="80px">State</th>

                                                <th>Digital Chargeslip</th>
                                                <th>UBC digital Invoice</th>
                                                <th>Product Amount</th>
                                                <th>Sale Amount</th>
                                                <th>Transaction Amount</th>
                                                <th>Loan Amount</th>
                                                <th>EMI Amount</th>
                                                <th>Instant Discount/Cashback</th>
                                                <th>No Cost EMI Amount</th>
                                                <th>Additional Cashback</th>
                                                <th>Transaction Date</th>
                                                <th>Transaction Time</th>
                                                <th>Bank Merchant Id</th>
                                                <th>Btid</th>
                                                <th>Utid</th>
                                                <th>Card Number</th>
                                                <th>Bin No</th>
                                                <th>Acquiring Bank</th>
                                                <th>Issuer Bank</th>
                                                <th>Tender Mode</th>
                                                <th>Scheme</th>
                                                <th>Grade</th>
                                                <th>Logo</th>
                                                <th>Credit/Debit</th>
                                                <th>UPI Account Type</th>
                                                <th>RRN No</th>
                                                <th>Acquirer RRN Number</th>
                                                <th>Approval Code</th>
                                                <th>Merchant Invoice Number</th>
                                                <th>Batchsrl</th>
                                                <th>Invoice</th>

                                                <th>Processing Code</th>
                                                <th>Transaction Type</th>
                                                <th>Card Holder Name</th>
                                                <th>Is DCC Transaction</th>
                                                <th>Is International Card</th>
                                                <th>Transaction Medium</th>
                                                <th>Software Version</th>
                                                <th>Terminal Serial Number</th>
                                                {this.state.object_code.includes("LVIS0338")===true?
                                                <th>PNR Number</th>:<th>Bill Invoice Number</th>}
                                                <th>Settlement Date</th>
                                                <th>Settled/Unsettled</th>
                                                <th>Fallback</th>
                                                <th>Co Reason Message</th>
                                                <th width="150">Ufe Message</th>
                                                <th>Grab Order ID</th>
                                                <th>Pos Order ID</th>
                                                <th>Grab Client ID</th>
                                                <th>Pos Merchant ID</th>
                                                <th>Prim ID</th>
                                                <th>Parent Prim ID</th>
                                                <th>UHID</th>
                                                <th>Bill No</th>
                                                <th>Episode No</th>
                                                <th>Brand</th>
                                                <th>Merchant SKU</th>
                                                <th>Category</th>
                                                <th>Service Type</th>
                                                <th>Innoviti Convenience Fee</th>
                                                <th>Industry Category</th>
                                                <th>UPI Transaction ID</th>
                                                <th>ProviderReferenceID</th>
                                                {
                                                    this.state.extraColumns.map((column_name, i) => {
                                                        if (column_name !== "UBC digital Invoice") {
                                                            return <th>{column_name}</th>;
                                                        }
                                                    })
                                                }
                                            </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>
                                    <MultiCsvReportDownload ref="downloadAllReport" />

                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
        currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
}
export default connect(null,mapDispatchToProps)(LiveTransactionReport)